module.exports = __webpack_public_path__ + "img/sort／web／IO@2x.409a88bb.png";